// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store' // 引入store
import resource from 'vue-resource' // 引入vue-resource
import tabbar from './components/tabbar.vue'
import banner from './components/banner.vue'
import back from './components/back.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.component('tabbar',tabbar)
Vue.component('banner',banner)
Vue.component('back',back)
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(resource)
import common from './script/common.js'
Vue.use(common)
//Vue.prototype.common=common
// Vue.http.options.emulateJSON = true;
// Vue.http.options.headers = {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};

// Vue.http.interceptors.push((request, next) => {
// next((response) => {}

// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js